import React from 'react';

import { ConnectedSpaceInfoProvider } from '~src/spacesPlatform/components/Explorer/helpers/SpaceInfoProvider';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '~src/spacesPlatform/state/SpaceInfo';

import { ServerInfoService } from '../services/ServerInfoService';
import { Host } from '../types/Host';
import { ServerStatus } from './ServerStatus';

export interface ServerStatusSpaceProvideState {
  hosts: Host[];
}

const ServerStatusSpaceInfo: SpaceInfo = {
  spaceType: 'serverstatus',
  subspaceName: undefined,
  item: SpaceItemForNonEntitySpace
};

const PollMS = 60000;

export class ServerStatusSpaceProvider extends React.PureComponent<{}, ServerStatusSpaceProvideState> {
  private intervalId: number;

  public constructor(props: {}) {
    super(props);
    this.state = {
      hosts: []
    };
  }

  public componentDidMount() {
    this.setHosts();
    //Fetch updates every 60 seconds
    this.intervalId = window.setInterval(this.setHosts, PollMS);
  }

  public componentWillUnmount() {
    this.intervalId ? window.clearInterval(this.intervalId) : null;
  }

  public render() {
    return (
      <ConnectedSpaceInfoProvider spaceInfo={ServerStatusSpaceInfo}>
          <ServerStatus hosts={this.state.hosts} triggerRefresh={this.triggerRefresh}/>
      </ConnectedSpaceInfoProvider>
    );
  }

  private setHosts = async (): Promise<void> => {
    const hosts = await ServerInfoService.fetch();
    this.setState({ hosts: hosts });
  };

  private triggerRefresh = (): Promise<void> => {
    this.setState({hosts: []}); // Workaround to show spinner if refresh is manually triggered
    this.intervalId && window.clearInterval(this.intervalId); //clear the existing timeout
    this.intervalId = window.setInterval(this.setHosts, PollMS); //Set new interval from the current time
    return this.setHosts();
  };

}
